import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LinePumpIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M20.54 6.29 19 4.75l-1.41-1.41a1.003 1.003 0 0 0-.71-.294 1.0036 1.0036 0 0 0-.71.294 1.0052 1.0052 0 0 0-.2177 1.0942c.0505.1219.1245.2326.2177.3258l1 1-.83 2.49a3.0002 3.0002 0 0 0 .73 3.07l2.95 3V19a1.0001 1.0001 0 0 1-2 0v-2a3 3 0 0 0-3-3H14V5a3 3 0 0 0-3-3H5a3 3 0 0 0-3 3v14a3 3 0 0 0 3 3h6a3 3 0 0 0 3-3v-3h1a1.0001 1.0001 0 0 1 1 1v2a3 3 0 0 0 6 0V9.83a4.9999 4.9999 0 0 0-1.46-3.54ZM12 19a1.0001 1.0001 0 0 1-1 1H5a1.0002 1.0002 0 0 1-1-1v-7h8v7Zm0-9H4V5a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1v5Zm8 1.42-1.54-1.54a1.0004 1.0004 0 0 1-.24-1l.51-1.54.39.4A3 3 0 0 1 20 9.83v1.59Z"/>
  </SvgIcon>
}

export default LinePumpIcon
